// extracted by mini-css-extract-plugin
module.exports = {"PortfolioList":"ComponentBodyPortfolioList_PortfolioList__9bFVn","Navigation":"ComponentBodyPortfolioList_Navigation__dojDU","Logo":"ComponentBodyPortfolioList_Logo__aMaSQ"};